(function () {
  const CHILD_PROPERTY_LABEL = 'Enfant';
  const CHILD_FIRST_PRIVATE = '_child_first_name';
  const CHILD_LAST_PRIVATE = '_child_last_name';
  const SELLING_PLAN_REQUIRED_ERROR = 'This product requires a selling plan, but no valid plan is available for this variant.';
  const DEBUG_PREFIX = '[new-main-product]';
  const MODAL_CUSTOM_PROPERTIES = [
    '--nmp-text',
    '--nmp-border',
    '--nmp-button-bg',
    '--nmp-button-color',
    '--nmp-button-fold',
    '--nmp-modal-bg',
  ];

  window.NewMainProductDebug = window.NewMainProductDebug || {};
  window.NewMainProductDebug.enabled = window.NewMainProductDebug.enabled === true;

  function isDebugEnabled() {
    return window.NewMainProductDebug && window.NewMainProductDebug.enabled !== false;
  }

  function debug(label, data) {
    if (!isDebugEnabled()) return;
    if (typeof data === 'undefined') {
      console.log(`${DEBUG_PREFIX} ${label}`);
    } else {
      console.log(`${DEBUG_PREFIX} ${label}`, data);
    }
  }

  function debugWarn(label, data) {
    if (!isDebugEnabled()) return;
    console.warn(`${DEBUG_PREFIX} ${label}`, data);
  }

  function cloneForDebug(value) {
    try {
      return JSON.parse(JSON.stringify(value));
    } catch (error) {
      return value;
    }
  }

  function getCartAddJsonUrl() {
    const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
    return `${root.replace(/\/?$/, '/')}cart/add.js`;
  }

  function getChildModal(section) {
    const sectionId = section.dataset.section || section.id.replace(/^NewMainProduct-/, '');
    const modalId = `NewMainProductModalTitle-${sectionId}`;

    return section.querySelector('[data-new-main-product-modal]')
      || document.querySelector(`[data-new-main-product-modal][aria-labelledby="${modalId}"]`);
  }

  function syncModalCustomProperties(modal, source, properties) {
    if (!modal || !source) return;

    const styles = window.getComputedStyle(source);
    properties.forEach((property) => {
      const value = styles.getPropertyValue(property);
      if (value) modal.style.setProperty(property, value.trim());
    });
  }

  function mountModalAtRoot(modal, source, properties) {
    if (!modal) return;

    syncModalCustomProperties(modal, source, properties);

    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }
  }

  let productModalTouchStartY = 0;

  function rememberProductModalTouchStart(event) {
    productModalTouchStartY = event.touches && event.touches.length ? event.touches[0].clientY : 0;
  }

  function preventProductModalBackgroundTouch(event) {
    const target = event.target;
    const element = target && target.nodeType === 1 ? target : target?.parentElement;
    const scrollContainer = element
      ? element.closest('.new-main-product-modal__dialog, .coffret-main-product-modal__dialog')
      : null;

    if (scrollContainer) {
      const currentY = event.touches && event.touches.length ? event.touches[0].clientY : productModalTouchStartY;
      const deltaY = currentY - productModalTouchStartY;
      const atTop = scrollContainer.scrollTop <= 0;
      const atBottom = scrollContainer.scrollTop + scrollContainer.clientHeight >= scrollContainer.scrollHeight - 1;

      if ((atTop && deltaY > 0) || (atBottom && deltaY < 0)) {
        event.preventDefault();
      }
      return;
    }

    event.preventDefault();
  }

  function updateModalViewport(modal) {
    if (!modal) return;

    const visualViewport = window.visualViewport;
    const height = visualViewport && visualViewport.height
      ? Math.max(Math.round(visualViewport.height), 1)
      : Math.max(window.innerHeight || document.documentElement.clientHeight || 1, 1);
    const offsetTop = visualViewport && visualViewport.offsetTop
      ? Math.max(Math.round(visualViewport.offsetTop), 0)
      : 0;
    modal.style.setProperty('--product-modal-vh', `${height}px`);
    modal.style.setProperty('--product-modal-visual-height', `${height}px`);
    modal.style.setProperty('--product-modal-offset-top', `${offsetTop}px`);
    modal.style.setProperty('--product-modal-visual-top', `${offsetTop}px`);
  }

  function updateOpenModalViewports() {
    document
      .querySelectorAll('.new-main-product-modal:not([hidden]), .coffret-main-product-modal:not([hidden])')
      .forEach(updateModalViewport);
  }

  function watchModalViewport(modal) {
    if (!modal) return;
    if (modal.productModalViewportCleanup) {
      modal.productModalViewportCleanup();
    }

    let frame = null;
    const scheduleUpdate = () => {
      if (frame !== null) return;
      frame = window.requestAnimationFrame(() => {
        frame = null;
        updateModalViewport(modal);
      });
    };

    updateModalViewport(modal);
    window.addEventListener('resize', scheduleUpdate);
    window.addEventListener('orientationchange', scheduleUpdate);
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', scheduleUpdate);
      window.visualViewport.addEventListener('scroll', scheduleUpdate);
    }

    modal.productModalViewportCleanup = () => {
      if (frame !== null) {
        window.cancelAnimationFrame(frame);
      }
      window.removeEventListener('resize', scheduleUpdate);
      window.removeEventListener('orientationchange', scheduleUpdate);
      if (window.visualViewport) {
        window.visualViewport.removeEventListener('resize', scheduleUpdate);
        window.visualViewport.removeEventListener('scroll', scheduleUpdate);
      }
      modal.style.removeProperty('--product-modal-vh');
      modal.style.removeProperty('--product-modal-visual-height');
      modal.style.removeProperty('--product-modal-offset-top');
      modal.style.removeProperty('--product-modal-visual-top');
      modal.productModalViewportCleanup = null;
    };
  }

  function stopModalViewportWatch(modal) {
    if (modal && modal.productModalViewportCleanup) {
      modal.productModalViewportCleanup();
    }
  }

  function keepFocusedControlInsideModal(control) {
    const scrollContainer = control.closest('.new-main-product-modal__dialog, .coffret-main-product-modal__dialog');
    if (!scrollContainer) return;

    const containerRect = scrollContainer.getBoundingClientRect();
    const controlRect = control.getBoundingClientRect();
    const topPadding = 16;
    const bottomPadding = 32;
    const minVisibleTop = containerRect.top + topPadding;
    const maxVisibleBottom = containerRect.bottom - bottomPadding;

    if (controlRect.bottom > maxVisibleBottom) {
      scrollContainer.scrollTop += controlRect.bottom - maxVisibleBottom;
    } else if (controlRect.top < minVisibleTop) {
      scrollContainer.scrollTop -= minVisibleTop - controlRect.top;
    }
  }

  function stabilizeProductModalFocus(event) {
    const control = event.target;
    if (!control || !control.matches || !control.matches('input, textarea, select')) return;
    if (!control.closest('.new-main-product-modal, .coffret-main-product-modal')) return;

    const stabilize = () => {
      updateOpenModalViewports();
      keepFocusedControlInsideModal(control);
    };

    window.requestAnimationFrame(stabilize);
    window.setTimeout(stabilize, 250);
    window.setTimeout(stabilize, 500);
    window.setTimeout(stabilize, 800);
  }

  function blurActiveModalElement(modal) {
    const activeElement = document.activeElement;
    if (activeElement && modal.contains(activeElement) && typeof activeElement.blur === 'function') {
      activeElement.blur();
    }
  }

  function lockPageScroll(lockClass) {
    const root = document.documentElement;

    if (document.body.dataset.productModalScrollLocked !== 'true') {
      const scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
      document.body.dataset.productModalScrollLocked = 'true';
      document.body.dataset.productModalScrollY = String(scrollY);
      document.body.dataset.productModalPreviousHtmlOverflow = root.style.overflow || '';
      document.body.dataset.productModalPreviousBodyOverflow = document.body.style.overflow || '';
      document.body.dataset.productModalPreviousBodyPosition = document.body.style.position || '';
      document.body.dataset.productModalPreviousBodyTop = document.body.style.top || '';
      document.body.dataset.productModalPreviousBodyLeft = document.body.style.left || '';
      document.body.dataset.productModalPreviousBodyRight = document.body.style.right || '';
      document.body.dataset.productModalPreviousBodyWidth = document.body.style.width || '';
      document.body.dataset.productModalPreviousHtmlOverscroll = root.style.overscrollBehavior || '';
      document.body.dataset.productModalPreviousBodyOverscroll = document.body.style.overscrollBehavior || '';
      root.style.overflow = 'hidden';
      root.style.overscrollBehavior = 'none';
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
      document.body.style.overscrollBehavior = 'none';
      document.addEventListener('touchstart', rememberProductModalTouchStart, { passive: true });
      document.addEventListener('touchmove', preventProductModalBackgroundTouch, { passive: false });
      document.addEventListener('focusin', stabilizeProductModalFocus, true);
    }

    root.classList.add(lockClass);
    document.body.classList.add(lockClass);
  }

  function unlockPageScroll(lockClass) {
    const root = document.documentElement;

    root.classList.remove(lockClass);
    document.body.classList.remove(lockClass);

    if (document.querySelector('.new-main-product-modal:not([hidden]), .coffret-main-product-modal:not([hidden])')) {
      return;
    }

    if (document.body.dataset.productModalScrollLocked !== 'true') return;

    const scrollY = parseInt(document.body.dataset.productModalScrollY || '0', 10) || 0;
    root.style.overflow = document.body.dataset.productModalPreviousHtmlOverflow || '';
    root.style.overscrollBehavior = document.body.dataset.productModalPreviousHtmlOverscroll || '';
    document.body.style.overflow = document.body.dataset.productModalPreviousBodyOverflow || '';
    document.body.style.position = document.body.dataset.productModalPreviousBodyPosition || '';
    document.body.style.top = document.body.dataset.productModalPreviousBodyTop || '';
    document.body.style.left = document.body.dataset.productModalPreviousBodyLeft || '';
    document.body.style.right = document.body.dataset.productModalPreviousBodyRight || '';
    document.body.style.width = document.body.dataset.productModalPreviousBodyWidth || '';
    document.body.style.overscrollBehavior = document.body.dataset.productModalPreviousBodyOverscroll || '';
    document.removeEventListener('touchstart', rememberProductModalTouchStart);
    document.removeEventListener('touchmove', preventProductModalBackgroundTouch);
    document.removeEventListener('focusin', stabilizeProductModalFocus, true);
    delete document.body.dataset.productModalScrollLocked;
    delete document.body.dataset.productModalScrollY;
    delete document.body.dataset.productModalPreviousHtmlOverflow;
    delete document.body.dataset.productModalPreviousBodyOverflow;
    delete document.body.dataset.productModalPreviousBodyPosition;
    delete document.body.dataset.productModalPreviousBodyTop;
    delete document.body.dataset.productModalPreviousBodyLeft;
    delete document.body.dataset.productModalPreviousBodyRight;
    delete document.body.dataset.productModalPreviousBodyWidth;
    delete document.body.dataset.productModalPreviousHtmlOverscroll;
    delete document.body.dataset.productModalPreviousBodyOverscroll;
    window.scrollTo(0, scrollY);
    window.setTimeout(() => window.scrollTo(0, scrollY), 120);
  }

  function buildCartAddPayload(item) {
    const payloadItem = {
      id: String(item.id),
      quantity: item.quantity || 1,
    };

    if (item.selling_plan !== null && typeof item.selling_plan !== 'undefined' && item.selling_plan !== '') {
      payloadItem.selling_plan = item.selling_plan;
    }

    if (item.properties) {
      payloadItem.properties = {};
      Object.entries(item.properties).forEach(([key, value]) => {
        if (value === null || typeof value === 'undefined' || value === '') return;
        payloadItem.properties[key] = value;
      });
    }

    return {
      items: [payloadItem],
    };
  }

  function initNewMainProducts(root) {
    const scope = root || document;
    scope.querySelectorAll('[id^="NewMainProduct-"]').forEach((section) => {
      if (section.dataset.newMainProductInitialized === 'true') return;
      section.dataset.newMainProductInitialized = 'true';
      debug('init section', {
        sectionId: section.id,
        form: Boolean(section.querySelector('[data-new-main-product-form]')),
        sellingPlanData: cloneForDebug(parseSellingPlanData(section)),
      });
      initGallery(section);
      initAddonLinks(section);
      initSellingPlans(section);
      initForm(section);
    });
  }

  function initGallery(section) {
    const gallery = section.querySelector('[data-new-main-product-gallery]');
    if (!gallery) return;

    const thumbsTrack = gallery.querySelector('[data-new-main-product-thumbs]');
    const prevButton = gallery.querySelector('[data-new-main-product-thumbs-prev]');
    const nextButton = gallery.querySelector('[data-new-main-product-thumbs-next]');
    const galleryMain = gallery.querySelector('.new-main-product__gallery-main');
    const mobileMediaQuery = window.matchMedia('(max-width: 749px)');
    let thumbScrollFrame = null;
    let touchStartX = 0;
    let touchStartY = 0;
    let isTouchTracking = false;

    const updateThumbControls = () => {
      if (!thumbsTrack || !prevButton || !nextButton) return;

      const maxScrollLeft = Math.max(0, thumbsTrack.scrollWidth - thumbsTrack.clientWidth);
      const canScroll = maxScrollLeft > 1;
      prevButton.disabled = !canScroll || thumbsTrack.scrollLeft <= 1;
      nextButton.disabled = !canScroll || thumbsTrack.scrollLeft >= maxScrollLeft - 1;
    };

    const queueThumbControlUpdate = () => {
      if (thumbScrollFrame) window.cancelAnimationFrame(thumbScrollFrame);
      thumbScrollFrame = window.requestAnimationFrame(updateThumbControls);
    };

    const scrollThumbs = (direction) => {
      if (!thumbsTrack) return;
      const firstThumb = thumbsTrack.querySelector('[data-new-main-product-thumb]');
      const styles = window.getComputedStyle(thumbsTrack);
      const columnGap = parseFloat(styles.columnGap || styles.gap) || 0;
      const scrollDistance = firstThumb ? firstThumb.getBoundingClientRect().width + columnGap : thumbsTrack.clientWidth / 3;
      thumbsTrack.scrollBy({
        left: direction * Math.max(scrollDistance, 1),
        behavior: 'smooth',
      });
    };

    const getThumbs = () => Array.from(gallery.querySelectorAll('[data-new-main-product-thumb]'));

    const activateThumb = (thumb, scrollBehavior = 'smooth', scrollIntoView = true) => {
      if (!thumb) return;

      const mediaId = thumb.dataset.newMainProductThumb;
      gallery.querySelectorAll('[data-new-main-product-media]').forEach((panel) => {
        panel.classList.toggle('is-active', panel.dataset.newMainProductMedia === mediaId);
      });
      getThumbs().forEach((button) => {
        const isActive = button === thumb;
        button.classList.toggle('is-active', isActive);
        if (isActive) {
          button.setAttribute('aria-current', 'true');
        } else {
          button.removeAttribute('aria-current');
        }
      });

      if (scrollIntoView) {
        thumb.scrollIntoView({
          behavior: scrollBehavior,
          block: 'nearest',
          inline: 'nearest',
        });
      }
      window.setTimeout(updateThumbControls, scrollBehavior === 'smooth' ? 250 : 0);
    };

    const activateAdjacentThumb = (direction) => {
      const thumbs = getThumbs();
      if (!thumbs.length) return;

      const activeIndex = Math.max(thumbs.findIndex((thumb) => thumb.classList.contains('is-active')), 0);
      const nextIndex = Math.min(Math.max(activeIndex + direction, 0), thumbs.length - 1);

      if (nextIndex === activeIndex) return;

      activateThumb(thumbs[nextIndex], 'smooth', false);
      scrollThumbs(direction);
    };

    const onGalleryTouchStart = (event) => {
      isTouchTracking = false;
      if (!mobileMediaQuery.matches || !event.touches || event.touches.length !== 1) return;

      touchStartX = event.touches[0].clientX;
      touchStartY = event.touches[0].clientY;
      isTouchTracking = true;
    };

    const onGalleryTouchEnd = (event) => {
      if (!isTouchTracking || !mobileMediaQuery.matches || !event.changedTouches || event.changedTouches.length !== 1) {
        isTouchTracking = false;
        return;
      }

      isTouchTracking = false;

      const deltaX = event.changedTouches[0].clientX - touchStartX;
      const deltaY = event.changedTouches[0].clientY - touchStartY;
      const absX = Math.abs(deltaX);
      const absY = Math.abs(deltaY);

      if (absX < 40 || absX < absY * 1.25) return;

      activateAdjacentThumb(deltaX < 0 ? 1 : -1);
    };

    gallery.addEventListener('click', (event) => {
      const thumb = event.target.closest('[data-new-main-product-thumb]');
      if (!thumb) return;

      activateThumb(thumb);
    });

    if (galleryMain) {
      galleryMain.addEventListener('touchstart', onGalleryTouchStart, { passive: true });
      galleryMain.addEventListener('touchend', onGalleryTouchEnd, { passive: true });
    }

    if (prevButton) {
      prevButton.addEventListener('click', () => scrollThumbs(-1));
    }

    if (nextButton) {
      nextButton.addEventListener('click', () => scrollThumbs(1));
    }

    if (thumbsTrack) {
      thumbsTrack.addEventListener('scroll', queueThumbControlUpdate, { passive: true });
      window.addEventListener('resize', queueThumbControlUpdate);
      const activeThumb = gallery.querySelector('[data-new-main-product-thumb].is-active');
      if (activeThumb) activeThumb.setAttribute('aria-current', 'true');
      updateThumbControls();
    }
  }

  function initAddonLinks(section) {
    section.querySelectorAll('[data-new-main-product-addon-link]').forEach((link) => {
      link.addEventListener('click', (event) => {
        event.stopPropagation();
      });
    });
  }

  function initSellingPlans(section) {
    const form = section.querySelector('[data-new-main-product-form]');
    if (!form) return;

    updateSellingPlanOptions(section, form);

    const variantInput = form.querySelector('input[name="id"]');
    if (variantInput) {
      variantInput.addEventListener('change', () => {
        updateSellingPlanOptions(section, form);
        restoreCustomButtonLabel(form);
      });
    }

    if (window.PUB_SUB_EVENTS && window.subscribe) {
      window.subscribe(window.PUB_SUB_EVENTS.variantChange, (event) => {
        if (!event || !event.data || event.data.sectionId !== form.dataset.sectionId) return;
        window.setTimeout(() => {
          updateSellingPlanOptions(section, form);
          restoreCustomButtonLabel(form);
        }, 0);
      });
    }
  }

  function parseSellingPlanData(section) {
    const script = section.querySelector('[data-new-main-product-selling-plans]');
    if (!script) return null;

    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      console.warn('[new-main-product] Invalid selling plan data', error);
      return null;
    }
  }

  function updateSellingPlanOptions(section, form) {
    const planInput = form.querySelector('[data-new-main-product-selling-plan]');
    if (!planInput) {
      debug('updateSellingPlanOptions: no selling plan input in form', {
        sectionId: section.id,
        variantId: getVariantId(form),
      });
      return;
    }

    const planState = getVariantSellingPlanState(section, form);
    if (!planState.data || !planState.data.variants) {
      debugWarn('updateSellingPlanOptions: missing selling plan JSON data', {
        sectionId: section.id,
        variantId: getVariantId(form),
      });
      return;
    }

    debug('updateSellingPlanOptions: variant plans', {
      sectionId: section.id,
      variantId: planState.variantId,
      inputType: planInput.tagName,
      currentInputValue: planInput.value,
      productRequiresSellingPlan: planState.data.productRequiresSellingPlan,
      variantRequiresSellingPlan: planState.requiresSellingPlan,
      variantPlans: cloneForDebug(planState.plans),
    });

    if (planInput.tagName !== 'SELECT') {
      planInput.value = getSellingPlanId(section, form);
      debug('updateSellingPlanOptions: hidden input value after update', {
        variantId: planState.variantId,
        value: planInput.value,
      });
      return;
    }

    const previousValue = planInput.value;
    const emptyOption = planInput.querySelector('option[value=""]');
    const emptyLabel = emptyOption ? emptyOption.textContent : 'Achat unique';
    const allowEmpty = planState.requiresSellingPlan !== true;

    planInput.innerHTML = '';

    planState.plans.forEach((plan) => {
      const option = document.createElement('option');
      option.value = plan.id;
      option.textContent = plan.name;
      planInput.appendChild(option);
    });

    if (allowEmpty) {
      const option = document.createElement('option');
      option.value = '';
      option.textContent = emptyLabel;
      planInput.appendChild(option);
    }

    const hasPreviousPlanValue = isPlanValidForVariant(previousValue, planState.plans);
    if (hasPreviousPlanValue) {
      planInput.value = previousValue;
    } else if (allowEmpty && previousValue === '') {
      planInput.value = '';
    } else if (planState.plans.length) {
      planInput.value = planState.plans[0].id;
    } else {
      planInput.value = '';
    }

    planInput.disabled = !allowEmpty && planState.plans.length === 0;
    debug('updateSellingPlanOptions: select value after update', {
      variantId: planState.variantId,
      value: planInput.value,
      disabled: planInput.disabled,
      optionValues: Array.from(planInput.options).map((option) => option.value),
    });
  }

  function initForm(section) {
    const form = section.querySelector('[data-new-main-product-form]');
    if (!form) return;

    const modal = getChildModal(section);
    const childForm = modal ? modal.querySelector('[data-new-main-product-child-form]') : null;
    let pendingForm = null;

    if (modal) {
      mountModalAtRoot(modal, section, MODAL_CUSTOM_PROPERTIES);
    }

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      event.stopPropagation();

      clearFormError(form);
      debug('form submit intercepted', {
        sectionId: section.id,
        variantId: getVariantId(form),
        quantity: getQuantity(form),
        formSellingPlanValue: form.querySelector('[data-new-main-product-selling-plan]')?.value || '',
        subscriptionSelection: isSubscriptionSelection(section, form),
      });

      const sellingPlanError = getSellingPlanValidationError(section, form);
      if (sellingPlanError) {
        showFormError(form, sellingPlanError);
        return;
      }

      if (modal && isSubscriptionSelection(section, form)) {
        pendingForm = form;
        openChildModal(section, modal);
        return;
      }

      submitProductForm(section, form);
    });

    if (modal && childForm) {
      modal.querySelectorAll('[data-new-main-product-modal-close]').forEach((button) => {
        button.addEventListener('click', () => {
          pendingForm = null;
          closeChildModal(modal);
        });
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !modal.hidden) {
          pendingForm = null;
          closeChildModal(modal);
        }
      });

      childForm.addEventListener('submit', (event) => {
        event.preventDefault();
        if (!pendingForm) return;

        const childData = getChildFormData(childForm);
        const error = modal.querySelector('[data-new-main-product-child-error]');
        if (!childData) {
          if (error) error.hidden = false;
          return;
        }

        if (error) error.hidden = true;
        const formToSubmit = pendingForm;
        pendingForm = null;
        closeChildModal(modal);
        submitProductForm(section, formToSubmit, childData);
      });
    }
  }

  function getChildFormData(childForm) {
    const firstInput = childForm.querySelector('[name="child_first_name"]');
    const lastInput = childForm.querySelector('[name="child_last_name"]');
    const firstName = firstInput ? firstInput.value.trim() : '';
    const lastName = lastInput ? lastInput.value.trim() : '';

    childForm.querySelectorAll('input[required]').forEach((input) => {
      input.toggleAttribute('aria-invalid', input.value.trim() === '');
    });

    if (!firstName || !lastName) return null;

    return {
      firstName,
      lastName,
      fullName: `${firstName} ${lastName}`.trim(),
    };
  }

  function openChildModal(section, modal) {
    syncModalCustomProperties(modal, section, MODAL_CUSTOM_PROPERTIES);
    modal.hidden = false;
    watchModalViewport(modal);
    lockPageScroll('new-main-product-modal-open');
    const dialog = modal.querySelector('.new-main-product-modal__dialog');
    if (dialog) dialog.scrollTop = 0;
    const content = modal.querySelector('.new-main-product-modal__content');
    if (content) content.scrollTop = 0;
  }

  function closeChildModal(modal) {
    blurActiveModalElement(modal);
    modal.hidden = true;
    stopModalViewportWatch(modal);
    unlockPageScroll('new-main-product-modal-open');
  }

  function isSubscriptionSelection(section, form) {
    const planState = getVariantSellingPlanState(section, form);
    const sellingPlanId = getSellingPlanId(section, form);
    const result =
      planState.requiresSellingPlan === true ||
      form.dataset.requiresSellingPlan === 'true' ||
      (form.dataset.triggerSellingPlan === 'true' && Boolean(sellingPlanId));
    debug('isSubscriptionSelection', {
      variantId: planState.variantId,
      requiresSellingPlan: form.dataset.requiresSellingPlan,
      triggerSellingPlan: form.dataset.triggerSellingPlan,
      variantRequiresSellingPlan: planState.requiresSellingPlan,
      variantPlans: cloneForDebug(planState.plans),
      sellingPlanId,
      result,
    });
    return result;
  }

  function getSellingPlanValidationError(section, form) {
    const planState = getVariantSellingPlanState(section, form);
    const sellingPlanId = getSellingPlanId(section, form);
    debug('selling plan validation', {
      variantId: planState.variantId,
      variantRequiresSellingPlan: planState.requiresSellingPlan,
      variantPlans: cloneForDebug(planState.plans),
      selectedSellingPlanId: sellingPlanId,
    });

    if (planState.requiresSellingPlan && !sellingPlanId) {
      return SELLING_PLAN_REQUIRED_ERROR;
    }

    return '';
  }

  function getVariantId(form) {
    const input = form.querySelector('input[name="id"]');
    return input ? input.value : '';
  }

  function getQuantity(form) {
    const input = form.querySelector('[name="quantity"]');
    const quantity = input ? parseInt(input.value, 10) : 1;
    return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
  }

  function getVariantSellingPlanState(section, form) {
    const data = parseSellingPlanData(section);
    const variantId = getVariantId(form);
    const variantData = data && data.variants ? data.variants[String(variantId)] || null : null;
    const plans = variantData && Array.isArray(variantData.plans)
      ? variantData.plans.filter((plan) => plan && plan.id)
      : [];
    const requiresSellingPlan =
      variantData && typeof variantData.requiresSellingPlan === 'boolean'
        ? variantData.requiresSellingPlan
        : Boolean(data && data.productRequiresSellingPlan);

    return {
      data,
      variantId,
      variantData,
      plans,
      requiresSellingPlan,
    };
  }

  function isPlanValidForVariant(planId, plans) {
    if (!planId) return false;
    return plans.some((plan) => String(plan.id) === String(planId));
  }

  function getSellingPlanId(section, form) {
    const sellingPlan = form.querySelector('[data-new-main-product-selling-plan]');
    const currentPlanId = sellingPlan && sellingPlan.value ? sellingPlan.value : '';
    const planState = getVariantSellingPlanState(section, form);

    if (
      sellingPlan &&
      sellingPlan.tagName === 'SELECT' &&
      currentPlanId === '' &&
      planState.requiresSellingPlan !== true
    ) {
      return '';
    }

    if (isPlanValidForVariant(currentPlanId, planState.plans)) {
      return String(currentPlanId);
    }

    if (planState.plans.length) {
      return String(planState.plans[0].id);
    }

    return '';
  }

  function normalizeSellingPlanId(id) {
    if (!id) return '';
    return String(id);
  }

  function getCandidateSellingPlanIds(section, form) {
    const planState = getVariantSellingPlanState(section, form);
    const candidates = [];

    const addCandidate = (id) => {
      if (!id) return;
      const normalized = String(id);
      if (!candidates.includes(normalized)) candidates.push(normalized);
    };

    addCandidate(getSellingPlanId(section, form));
    planState.plans.forEach((plan) => addCandidate(plan.id));

    const normalizedCandidates = candidates.map(normalizeSellingPlanId).filter(Boolean);
    debug('candidate selling plans', {
      variantId: planState.variantId,
      formInputValue: form.querySelector('[data-new-main-product-selling-plan]')?.value || '',
      candidates,
      normalizedCandidates,
      variantRequiresSellingPlan: planState.requiresSellingPlan,
      variantPlans: cloneForDebug(planState.plans),
    });
    return normalizedCandidates;
  }

  function buildMainItem(section, form, childData) {
    const planState = getVariantSellingPlanState(section, form);
    const item = {
      id: getVariantId(form),
      quantity: getQuantity(form),
    };

    const sellingPlanId = getSellingPlanId(section, form);
    if (planState.requiresSellingPlan && !sellingPlanId) {
      throw new Error(SELLING_PLAN_REQUIRED_ERROR);
    }

    if (sellingPlanId) {
      item.selling_plan = normalizeSellingPlanId(sellingPlanId);
    }

    if (childData) {
      item.properties = {};
      item.properties[CHILD_PROPERTY_LABEL] = childData.fullName;
      item.properties[CHILD_FIRST_PRIVATE] = childData.firstName;
      item.properties[CHILD_LAST_PRIVATE] = childData.lastName;
    }

    debug('build main cart item', {
      variantId: item.id,
      quantity: item.quantity,
      sellingPlanId,
      variantRequiresSellingPlan: planState.requiresSellingPlan,
      variantPlans: cloneForDebug(planState.plans),
      allSellingPlanIds: planState.data && Array.isArray(planState.data.allSellingPlanIds) ? planState.data.allSellingPlanIds : [],
      selectedVariantSellingPlanAllocations: cloneForDebug(planState.variantData),
      payload: cloneForDebug(item),
    });

    return item;
  }

  async function addMainItemToCart(section, form, item) {
    const candidates = getCandidateSellingPlanIds(section, form);
    const attempted = new Set();
    debug('addMainItemToCart: start', {
      initialPayload: cloneForDebug(item),
      candidates,
    });

    const getAttemptKey = (attemptItem) => {
      if (!attemptItem.selling_plan) return 'no-selling-plan';
      return `${typeof attemptItem.selling_plan}:${String(attemptItem.selling_plan)}`;
    };

    const getAlternateSellingPlan = (sellingPlan) => {
      if (!sellingPlan) return null;
      if (typeof sellingPlan === 'string') {
        const numericPlan = Number(sellingPlan);
        return Number.isFinite(numericPlan) ? numericPlan : null;
      }
      if (typeof sellingPlan === 'number') {
        return String(sellingPlan);
      }
      return null;
    };

    const attemptAdd = async (attemptItem, label) => {
      attempted.add(getAttemptKey(attemptItem));
      debug(`addMainItemToCart: ${label}`, cloneForDebug(attemptItem));
      return addItemToCart(attemptItem);
    };

    if (item.selling_plan) {
      attempted.add(getAttemptKey(item));
    } else if (candidates.length) {
      item.selling_plan = candidates[0];
      attempted.add(getAttemptKey(item));
    }

    try {
      return await attemptAdd(item, 'primary attempt');
    } catch (error) {
      debugWarn('addMainItemToCart: primary attempt failed', cloneForDebug(error));

      const alternateSellingPlan = getAlternateSellingPlan(item.selling_plan);
      if (alternateSellingPlan !== null) {
        const alternateItem = {
          ...item,
          selling_plan: alternateSellingPlan,
        };
        const alternateKey = getAttemptKey(alternateItem);

        if (!attempted.has(alternateKey)) {
          try {
            return await attemptAdd(alternateItem, 'selling_plan type retry');
          } catch (alternateError) {
            debugWarn('addMainItemToCart: selling_plan type retry failed', cloneForDebug(alternateError));
            error = alternateError;
          }
        }
      }

      for (const candidate of candidates) {
        const retryPlans = [candidate];
        const alternateCandidate = getAlternateSellingPlan(candidate);
        if (alternateCandidate !== null) retryPlans.push(alternateCandidate);

        for (const retryPlan of retryPlans) {
          const retryItem = {
            ...item,
            selling_plan: retryPlan,
          };
          if (attempted.has(getAttemptKey(retryItem))) continue;

          try {
            return await attemptAdd(retryItem, 'retry attempt');
          } catch (retryError) {
            debugWarn('addMainItemToCart: retry failed', {
              candidate: retryPlan,
              error: cloneForDebug(retryError),
            });
            error = retryError;
          }
        }
      }

      debugWarn('addMainItemToCart: all attempts failed', cloneForDebug(error));
      throw error;
    }
  }

  function getAddonItems(form) {
    const items = [];
    const seen = new Set();
    const addItem = (id, quantity) => {
      if (!id || seen.has(String(id))) return;
      seen.add(String(id));
      items.push({
        id,
        quantity: quantity || 1,
      });
    };

    form.querySelectorAll('[data-new-main-product-addon]:checked:not(:disabled)').forEach((input) => {
      addItem(input.value, 1);
    });

    form.querySelectorAll('input[name^="items["][name$="[id]"]').forEach((input) => {
      const match = input.name.match(/^items\[(.+)]\[id]$/);
      const quantityInput = match ? form.querySelector(`input[name="items[${match[1]}][quantity]"]`) : null;
      const quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;
      addItem(input.value, Number.isFinite(quantity) && quantity > 0 ? quantity : 1);
    });

    debug('addon items', cloneForDebug(items));
    return items;
  }

  async function submitProductForm(section, form, childData) {
    const button = form.querySelector('[data-new-main-product-submit]');
    setLoading(button, true);
    clearFormError(form);

    try {
      updateSellingPlanOptions(section, form);
      const mainItem = buildMainItem(section, form, childData);
      if (!mainItem.id) throw new Error('Variant introuvable.');
      debug('submitProductForm: before main add', {
        mainItem: cloneForDebug(mainItem),
        childData: cloneForDebug(childData),
      });

      await addMainItemToCart(section, form, mainItem);

      const addonItems = getAddonItems(form);
      for (const item of addonItems) {
        await addItemToCart(item);
      }

      await refreshCartUI();
    } catch (error) {
      debugWarn('submitProductForm: failed', cloneForDebug(error));
      showFormError(form, getErrorMessage(error));
    } finally {
      setLoading(button, false);
    }
  }

  function addItemToCart(item) {
    const addUrl = getCartAddJsonUrl();
    const payload = buildCartAddPayload(item);
    const serializedBody = JSON.stringify(payload);
    debug('cart/add.js request', {
      url: addUrl,
      selectedVariantId: item.id,
      submittedSellingPlanId: item.selling_plan ? String(item.selling_plan) : '',
      payload: cloneForDebug(payload),
      sellingPlanType: typeof item.selling_plan,
    });
    return sendCartRequest(addUrl, serializedBody).catch((error) => {
      debugWarn('cart/add.js thrown error', cloneForDebug(error));
      throw error;
    });
  }

  function sendCartRequest(url, serializedBody) {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('POST', url, true);
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.setRequestHeader('Content-Type', 'application/json');

      xhr.onreadystatechange = () => {
        if (xhr.readyState !== XMLHttpRequest.DONE) return;

        let payload;
        try {
          payload = xhr.responseText ? JSON.parse(xhr.responseText) : {};
        } catch (parseError) {
          parseError.responseText = xhr.responseText;
          reject(parseError);
          return;
        }

        const ok = xhr.status >= 200 && xhr.status < 300 && !payload.status;
        debug('cart/add.js response', {
          ok,
          status: xhr.status,
          payload: cloneForDebug(payload),
        });

        if (ok) {
          resolve(payload);
        } else {
          reject(payload);
        }
      };

      xhr.onerror = () => {
        reject(new Error('Cart request failed.'));
      };

      xhr.send(serializedBody);
    });
  }

  async function refreshCartUI() {
    const cartDrawer = document.querySelector('cart-drawer');
    const cartUrl = window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';

    if (!cartDrawer || typeof cartDrawer.renderContents !== 'function') {
      window.location.href = cartUrl;
      return;
    }

    const response = await fetch(`${cartUrl}?sections=cart-drawer,cart-icon-bubble`);
    if (!response.ok) {
      cartDrawer.open();
      return;
    }

    const sections = await response.json();
    cartDrawer.classList.remove('is-empty');
    cartDrawer.renderContents({
      id: Date.now(),
      sections,
    });

    if (window.PUB_SUB_EVENTS && window.publish) {
      fetch('/cart.js')
        .then((cartResponse) => cartResponse.json())
        .then((cartData) => {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
            source: 'new-main-product',
            cartData,
          });
        })
        .catch(() => {});
    }
  }

  function setLoading(button, loading) {
    if (!button) return;
    button.classList.toggle('is-loading', loading);
    button.toggleAttribute('aria-disabled', loading);
    if (loading) {
      button.setAttribute('disabled', 'disabled');
    } else {
      button.removeAttribute('disabled');
      restoreCustomButtonLabel(button.closest('form'));
    }
  }

  function restoreCustomButtonLabel(form) {
    if (!form) return;
    const button = form.querySelector('[data-new-main-product-submit]');
    if (!button || button.disabled || button.hasAttribute('aria-disabled')) return;
    const label = button.dataset.addLabel;
    const labelElement = button.querySelector('.cta-corner__label');
    if (label && labelElement) labelElement.textContent = label;
  }

  function showFormError(form, message) {
    const error = form.querySelector('[data-new-main-product-form-error]');
    if (!error) return;
    error.textContent = message;
    error.hidden = false;
  }

  function clearFormError(form) {
    const error = form.querySelector('[data-new-main-product-form-error]');
    if (!error) return;
    error.textContent = '';
    error.hidden = true;
  }

  function getErrorMessage(error) {
    if (!error) return 'Something went wrong. Please try again.';
    if (typeof error === 'string') return error;
    if (error.description) return error.description;
    if (error.message) return error.message;
    if (error.errors) return Array.isArray(error.errors) ? error.errors.join(', ') : String(error.errors);
    return 'Something went wrong. Please try again.';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initNewMainProducts(document));
  } else {
    initNewMainProducts(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    initNewMainProducts(event.target);
  });
})();
